<template>
    <div class="main main-padding tabs-data-detailcs">
        <div class="top-area">
            <!--返回-->
            <div class="main-back">
                <div class="bank-back" v-on:click="gotoBack">
                    <img src="../../../assets/images/back.png"/>
                    <p class="click-text">返回</p>
                </div>
            </div>
        </div>
        <!--数据信息-->
        <card>
            <!--头部tab及搜索框-->
            <div class="card-header-area">
                <!--tab切换数据-->
                <div class="tab-data">
                    <Tabs type="card" @on-click="changeDataDetailsIndex" :value="tabsName">
                        <TabPane label="教师列表" name="teacherList"></TabPane>
                        <TabPane label="学生列表" name="studentList"></TabPane>
                    </Tabs>
                </div>
                <!--搜索框-->
                <div class="input-data">
                    <Input
                        v-model="keyWord"
                        placeholder="支持用户姓名搜索"
                        icon="ios-search"
                        clearable
                        @on-enter="handleSearch"
                    >
                        <Button
                            slot="append"
                            icon="ios-search"
                            class="search-input-button"
                            @click="handleSearch"
                            type="primary"
                        ></Button>
                    </Input>
                </div>
            </div>
            <div>
                <!--教师列表-->
                <div class="table-wrapper-data">
                    <Table :columns="userColumn" :data="userList"></Table>
                </div>
                <!--分页,大屏重复绑定情况下不显示-->
                <div class="laypage_main">
                    <Page
                        :total="total"
                        :current="page"
                        :page-size="limit"
                        @on-change="handleCurrentChange"
                        v-show="total && pageCount>1"
                        show-total
                    />
                </div>
            </div>
        </card>
    </div>
</template>

<script>
    import {getConversationUserList} from "../../../service/api.js";

    export default {
        name: "school-conservation-list",
        data () {
            return {
                keyWord: "",
                page: 1,
                limit: 10,
                total: 0,
                pageCount: 0,
                type: 1,//1 教师  , 2 学生
                schoolId: this.$route.query.schoolId,
                schoolName: this.$route.query.schoolName,
                userColumn: [
                    {
                        title: "序号",
                        key: "rowNum",
                        align: "center"
                    },
                    {
                        title: "用户姓名",
                        key: "userName",
                        align: "center",
                        render: (h, params) => {
                            return h("div", [
                                h(
                                    "a",
                                    {
                                        attrs: {
                                            title: "点击查看学校详情",
                                            href: "javascript:void(0);"
                                        },
                                        style: {
                                            color: "bule",
                                            fontSize: "12px"
                                        },
                                        on: {
                                            click: () => {
                                                this.lookUserDetails(params.row);
                                            }
                                        }
                                    },
                                    params.row.userName
                                )
                            ]);
                        }
                    },
                    {
                        title: "发送消息次数",
                        key: "sendCount",
                        align: "center"
                    }
                ],
                userList: []//用户列表
            }
        },
        methods: {
            /**
             * 返回上一页
             */
            gotoBack () {
                this.$router.push({
                    name: "conservationCount",
                });
            },
            /**
             * 点击tab切换数据信息
             */
            changeDataDetailsIndex (tabsName) {
                //初始化参数
                this.keyWord = "";
                this.page = 1;
                this.total = 0;
                this.pageCount = 0;
                this.userList = [];
                if (tabsName == 'teacherList') {
                    //显示教师列表
                    this.type = 1;
                } else if (tabsName == 'studentList') {
                    //获取学生列表
                    this.type = 2;
                }
                this.queryConversationUserList();
            },
            /**
             *翻页
             */
            handleCurrentChange (val) {
                this.page = val;
                this.queryConversationUserList();
            },
            /**
             *搜索关键字
             */
            handleSearch () {
                this.total = 0;
                this.page = 1;
                this.queryConversationUserList();
            },
            /**
             * 查看用户详情
             */
            lookUserDetails (row) {
                this.$router.push({
                    name: "userConservationDetails",
                    query: {
                        userId: row.userId,
                        schoolName: this.school_name,
                        type: this.type
                    }
                });
            },
            /**
             *获取用户列表
             */
            async queryConversationUserList () {
                let _this = this;
                let params = {
                    schoolId: _this.schoolId,
                    type: _this.type,
                    keyWord: _this.keyWord,
                    page: _this.page,
                    limit: _this.limit
                };
                await getConversationUserList(params)
                    .then(function (data) {
                        if (Object.keys(data).length !== 0) {
                            _this.userList = data.rows;
                            _this.total = data.total_rows;
                            _this.pageCount = Math.ceil(data.total_rows / _this.limit);
                        }
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            }
        },
        mounted () {
            // 查看用户列表
            this.queryConversationUserList();
            //修改公共属性学校名称
            this.$store.commit("SET_TOPHEADERNAME", this.schoolName);
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../style/home";
    @import "../../../style/dataDetails";

    .laypage_main {
        position: absolute;
        bottom: 15px;
        right: 15px;
    }
</style>
<style lang="scss">
    .tabs-data-detailcs {
        .ivu-input-group {
            width: 300px;
            float: right;
            top: 0;
        }

        .ivu-card-body {
            padding: 16px;
        }

        .ivu-input-group-append .ivu-btn, .ivu-input-group-prepend .ivu-btn {
            color: #fff;
            background: #57a3f3;
        }

        .time-slot .ivu-col-span-lg-4 {
            display: block;
            width: 355px;
        }

        .ivu-row {
            margin-top: 0 !important;
        }

        .ivu-input-group .ivu-input {
            font-size: 14px;
        }

        .ivu-btn-icon-only {
            border-radius: 0 4px 4px 0;
        }

        .ivu-input-icon-clear {
            margin-right: 45px;
        }

        .ivu-table {
            font-size: 14px;
        }

        .ivu-tabs-nav {
            font-size: 14px;
        }

        .ivu-table-overflowX {
            overflow-x: hidden;
        }
    }
</style>
